import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { TrackerUtil } from 'tracking/TrackerUtil';

const useContact = (elementId?: string) => {
  const { t } = useTranslation();

  const openCall = useCallback(() => {
    // Track the click on the phone number
    TrackerUtil.trackLinkClick(
      `${elementId ? `${elementId}_` : ''}link_phone-support`,
      'link_phone-support'
    );
    // Open call on device
    window.location.href = 'tel:' + t('headerPhoneSupportViewNumberToCall');
  }, [t, elementId]);

  const openEmail = useCallback(() => {
    // Track the click on the phone number
    TrackerUtil.trackLinkClick(
      `${elementId ? `${elementId}_` : ''}link_mail-support`,
      'link_mail-support'
    );
    // Open call on device
    window.location.href = 'tel:' + t('pageCentralHeatingFallbackEMail');
  }, [t, elementId]);

  return { openCall: openCall, openEmail: openEmail };
};

export default useContact;
